<template>
    <div class="web-feedback-panel shadow show">
        <div class="panel-header">
            <h3 class="panel-header-title">De door u gekozen locatie</h3>
            <!-- Close icon -->
            <icon-close
                :id="'web-feedback-location-close'"
                @close="$_onCancel(true)"
                class="d-inline-block float-right"
            >
            </icon-close>
        </div>
        <div class="panel-content">
            <!-- Address form -->
            <b-form
                name="web-feedback-location"
                enctype="multipart/form-data"
                v-on:submit.prevent="$_onSubmit"
            >
                <div class="form-group">
                    <div class="feedback-location-icon">
                        <img
                            src="~@/assets/imported-icons/ic_fluent_location_20_regular.svg"
                            alt="feedbacklocation"
                        />
                    </div>
                    <div class="d-inline-block">
                        <label>Adres</label>
                        <span class="span-readonly">{{ addressFull }}</span>
                        <span
                            class="span-readonly web-feedback-address-sub-label"
                            >(Klik opnieuw voor andere locatie)</span
                        >
                    </div>
                    <br />
                    <br />
                    <b-button
                        type="submit"
                        variant="primary"
                        class="float-right"
                    >
                        {{ $t('next') }}
                    </b-button>
                </div>
            </b-form>
        </div>
    </div>
</template>
<script>
    import IconClose from '../../../IconClose.vue';

    export default {
        name: 'WebFeedbackLocation',

        components: { 'icon-close': IconClose },

        props: { position: { type: Array, required: true } },

        data() {
            return {
                // Address at the position
                address1: null,
                address2: null,
                addressFull: null
            };
        },

        methods: {
            /**
             * Close this panel and open feedback add panel
             */
            $_onSubmit() {
                // Pass the address
                let webFeedbackAddress = null;

                // Only add part 1 if it has a value
                if (this.address1 && this.address1.length > 0) {
                    webFeedbackAddress = this.address1;
                }

                // Only add part 2 if it has a value
                if (this.address2 && this.address2.length > 0) {
                    webFeedbackAddress = `${webFeedbackAddress}, ${this.address2}`;
                }

                this.$emit('next', {
                    data: { adres: { value: webFeedbackAddress } }
                });
            },

            /**
             * Close this panel
             * @param {boolean} closeForm, true if user closed form with cancel button
             */
            $_onCancel() {
                this.$emit('close');
            },

            /**
             * Add webfeedback with new position
             */
            async $_showWebFeedbackLocation() {
                const location = this.position.toString();
                // Get address-info for this location (call web-api)
                const addressInfo = await this.$store.dispatch('useApiData', {
                    name: 'WebGetAddressInfo',
                    parameters: { location }
                });
                // Check if real address was found
                if (
                    addressInfo &&
                    addressInfo.data &&
                    addressInfo.data.streetName
                ) {
                    this.address1 = `${addressInfo.data.streetName} ${addressInfo.data.number}`;
                    this.address2 = `${addressInfo.data.city}`;
                    this.addressFull = `${this.address1}, ${this.address2}`;
                } else {
                    this.address1 = 'Geen adres gevonden.';
                    this.address2 = '';
                    this.addressFull = this.address1;
                }
            }
        },
        watch: {
            /**
             * Watch web-feedback location.
             * The new location selected for a web-feedback
             * @param  {boolean} newValue [new web-feedback location]
             */
            position: {
                handler: function () {
                    this.$_showWebFeedbackLocation();
                },
                immediate: true
            }
        }
    };
</script>

<style scoped lang="scss">
.web-feedback-panel {
    @include feedback-panel;
}

label {
    font-weight: normal;
}

.web-feedback-address-sub-label {
    color: #a2a0a0;
    font-weight: normal;
    padding-top: 8px;
}

@media (max-width: 767px) {
    .web-feedback-panel.show {
        width: 100%;
    }
}
</style>
